import Attachment from 'models/Attachment';
import { ReviewType } from 'models/Review';

export function getSummaryButtonTooltip({
  reviewType,
  attachments,
  allAttachmentsFailedProcessing,
}: {
  reviewType: ReviewType;
  attachments: Attachment[];
  allAttachmentsFailedProcessing: boolean;
}): string {
  if (attachments.length === 0) {
    return `No files attached to the ${reviewType} yet.`;
  }
  if (allAttachmentsFailedProcessing) {
    return 'All files have failed to process.';
  }
  return '';
}

export function getReturnUrlPath(path: string, endsWith: string = 'summary') {
  if (path.endsWith(`/${endsWith}`)) return path;
  const lastSlashIndex = path.lastIndexOf('/');
  return `${path.substring(0, lastSlashIndex)}/${endsWith}`;
}
